import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../view/index.vue'
import Article from '../view/article.vue'
import Search from '../view/search.vue'
Vue.use(VueRouter)
const routes = [
    {
        path: '/',
        redirect: '/index',
        meta: { title: "通威融媒", keepAlive: true,showLoad:true },
    },
    {
        path: '/index/:date?',
        meta: { title: "通威融媒", keepAlive: true,showLoad:true },
        component: Index
    },
    {
        path: '/article/:id',
        meta: { title: "通威融媒文章详情页", keepAlive: false },
        component: Article
    },
    {
        path: '/search/:k?',
        meta: { title: "搜索", keepAlive: false },
        component: Search
    },

]
const router = new VueRouter({
    mode:'history',
    routes
})
router.beforeEach((to, from, next) => {
    const toDepth = to.path.split('/').length
    const fromDepth = from.path.split('/').length
    console.log(to.path)
    console.log(from.path)
    if (to.meta.title) {
        document.title = to.meta.title
    }
    


    if (toDepth < fromDepth && /index/g.test(from.path)) {
        console.log('后退。。。')
        from.meta.keepAlive = false
        to.meta.keepAlive = true
        to.meta.showLoad = false
    }
    next()
})
export default router